import { useAppStore } from "../store/appStore";
import { Ico } from "./icons";
import { StatusDot } from "./atoms";

export function StatusBar() {
  const { panels, team, me } = useAppStore();
  const running = panels.filter((p) => p.status === "running").length;
  const thinking = panels.filter((p) => p.status === "thinking").length;
  const done = panels.filter((p) => p.status === "done").length;
  const totalSessions = team.reduce((n, t) => n + t.agents, 0);
  const onlineCount = team.filter((t) => t.online).length;

  return (
    <footer className="statusbar">
      <span className="group"><StatusDot status="running" size={6} /><span className="num">{running}</span> running</span>
      <span className="group"><StatusDot status="thinking" size={6} /><span className="num">{thinking}</span> thinking</span>
      <span className="group"><StatusDot status="done" size={6} /><span className="num">{done}</span> done</span>
      <span className="sep">·</span>
      <span className="group">{totalSessions} Session{totalSessions !== 1 ? "s" : ""} · {onlineCount} Dev{onlineCount !== 1 ? "s" : ""} online</span>
      <span className="spacer" />
      {me && (
        <>
          <span className="group"><Ico name="key" size={11} />{me.linuxUser}@claude.max</span>
          <span className="sep">·</span>
        </>
      )}
      <span className="group live"><span className="dot" />ClaudeFlow v0.1.0</span>
    </footer>
  );
}
